<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
    import wxscroll from '@/assets/wxscroll';
    export default {
        mounted() {
            wxscroll();
        }
    }
</script>
<style lang="scss">
    * {
        margin: 0;
        padding: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .mint-toast {
        z-index: 9999 !important;
    }

    .mint-popup {
        z-index: 3000 !important;
    }

    // 阿里巴巴图标库，生产环境请先下载后使用。
    @import '//at.alicdn.com/t/font_1608746_f68a2z8gr2m.css';
</style>
